const BarrierefreiheitPage = () => {
  return (
    <div className="w-full max-w-[1280px] mx-auto px-5 md:px-6 pt-[80px] pb-[48px]">
      <h1 className="!text-left text-[var(--primary)]">Barrierefreiheitserklärung</h1>

      <div className="mt-8 font-body text-[16px] [&_a]:underline [&_a]:font-extrabold [&_a]:text-black">
        <h2 className="mt-8">Erklärung zur Zugänglichkeit</h2>
        <p className="mt-3">
          Die Lucky Strike Webseite verpflichtet sich, die digitale Zugänglichkeit für alle Nutzer,
          einschließlich Menschen mit Behinderungen, zu gewährleisten. Wir arbeiten aktiv daran,
          die Anforderungen des <strong>European Accessibility Act (EAA)</strong> zu erfüllen und unsere Website an
          die <strong>Web Content Accessibility Guidelines (WCAG) 2.1 Level AA</strong> anzupassen.
        </p>

        <h2 className="mt-8">Laufende Bemühungen</h2>
        <p className="mt-3"><strong>VOLLSTÄNDIGE WCAG</strong></p>
        <p className="mt-3">
          Es wurde ein Zugänglichkeits-Audit durchgeführt, um die Übereinstimmung der Website mit den
          WCAG 2.2 AA-Standards zu bewerten, was über dem von vielen Rechts- und Verwaltungsvorschriften,
          einschließlich des Europäischen Zugänglichkeitsgesetzes, geforderten Standard liegt. Das Audit
          zeigt auf, wie gut die Website Nutzer mit Behinderungen unterstützt, indem sie anhand von Kriterien
          in vier Schlüsselprinzipien getestet wird: wahrnehmbar, bedienbar, verständlich und robust.
          Zu diesem Zweck wird die Website anhand einer Stichprobe von Webseiten anhand von neunundfünfzig (59) Kriterien bewertet.
        </p>
        <p className="mt-3">
          Obwohl viele Probleme mit der Barrierefreiheit bereits behoben wurden, sind wir uns darüber im Klaren,
          dass einige Barrieren weiterhin bestehen und die Erfahrungen bestimmter Nutzer beeinträchtigen können.
          Wir arbeiten derzeit vorrangig an der Lösung noch offener Probleme und an der Umsetzung von Verbesserungen
          im Rahmen unserer fortlaufenden Roadmap für Barrierefreiheit.
        </p>

        <h2 className="mt-8">Feedback und Kontakt</h2>
        <p className="mt-3">
          Wenn Sie Schwierigkeiten beim Zugriff auf Inhalte oder bei der Navigation auf der Website haben oder wenn
          Sie uns Feedback zu unseren Bemühungen um Barrierefreiheit geben möchten, setzen Sie sich bitte mit uns in Verbindung:
        </p>
        <p className="mt-3">
          <strong>E-Mail:</strong> <a href="mailto:service@lucky-strike.de" className="hover:opacity-80">service@lucky-strike.de</a>
        </p>
        <p>
          <strong>Telefon:</strong> <a href="tel:+800-5825437" className="hover:opacity-80">0800-5825437</a>
        </p>
        <p className="mt-3">
          Wir bemühen uns, alle Rückmeldungen innerhalb von 10 Werktagen zu beantworten und werden unser Bestes tun,
          um Ihnen die gewünschten Inhalte in einem zugänglichen Format zur Verfügung zu stellen.
        </p>

        <h2 className="mt-8">Status der Einhaltung</h2>
        <p className="mt-3">
          Diese Website erfüllt den WCAG 2.1 AA-Standard aufgrund der oben genannten Abweichungen nur teilweise.
          Wir arbeiten darauf hin, die Anforderungen des Europäischen Gesetzes über die Zugänglichkeit von Internetseiten
          innerhalb der geltenden Frist vollständig zu erfüllen.
        </p>

        <h2 className="mt-8">Datum der Erklärung</h2>
        <p className="mt-3">
          Diese Zugänglichkeitserklärung wurde zuletzt am 19.08.2025 aktualisiert.
        </p>
      </div>
    </div>
  );
};

export default BarrierefreiheitPage;
